// Creates an error with a custom name and optional status code
export class CustomError extends Error {
  public metadata?: Record<string, any> | null
  public statusCode?: number | null
  public retryable: boolean

  constructor(
    name: string,
    message: string,
    statusCode: number | null = null,
    metadata = null,
    retryable = false
  ) {
    super(message)
    this.name = name
    this.statusCode = statusCode
    this.metadata = metadata
    this.retryable = retryable

    if (
      Error.captureStackTrace &&
      typeof Error.captureStackTrace === 'function'
    ) {
      Error.captureStackTrace(this, CustomError)
    }
  }
}
